import { defineAsyncComponent } from 'vue'
export default {
  "auth-temp-layout": defineAsyncComponent(() => import("/home/runner/work/hive-ui/hive-ui/layouts/auth-temp-layout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/hive-ui/hive-ui/layouts/default.vue").then(m => m.default || m)),
  "trust-layout": defineAsyncComponent(() => import("/home/runner/work/hive-ui/hive-ui/layouts/trust-layout.vue").then(m => m.default || m))
}